module.exports = __webpack_public_path__ + "static/media/008.aa70a792.jpg";